<template>
  <div id="wrapper" class="m-2" style="height: 100%; overflow:auto;" :class="{ 'red-border': isRed, 'yellow-border': isYellow, 'green-border': isGreen }" ref="aicontainer">
    <div id="main">
      <div class="vid-container mb-4">
        <div class="canvas-wrapper">
          <canvas id="output" style="border-radius: 0.5em;"></canvas>
          <video id="video" playsinline style="
            -webkit-transform: scaleX(-1);
            transform: scaleX(-1);
            visibility: hidden;
            width: auto;
            height: auto;
            display: none;
            ">
          </video>
        </div>
        <div id="scatter-gl-container"></div>
      </div>

      <div class="m-2" v-if="score">
        <div v-if="score < threshold">
          <span style="color:#7CB342;"> Good posture, Keep going <i class="fas fa-check-circle"></i></span>
        </div>
        <div v-else>
          <span style="color:red;"> Please correct your posture as shown in the video and animation <i class="fas fa-exclamation-triangle"></i></span>
        </div>
      </div>

      <div id="yoga">
        <input id="similarityresult">
        <canvas id="yogaposeoutput" class="d-none"></canvas>
        <img crossorigin="anonymous" id="yogeposeimg" src="" width="500" height="600" style="visibility: hidden;display:none">
      </div>
    </div>

  </div>
</template>

<script>
import {
  initAiTracker,
  stopAnimation,
  stopVideoStream,
} from "../../../services/AI-yoga-tracker/index";

export default {
  props: ["aiReferenceImage", "aiThreshold"],

  async mounted() {
    let loader;
    setTimeout(() => {
      loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.aicontainer,
        canCancel: true,
      });
    }, 4000);
    try {
      if (this.aiThreshold && this.aiThreshold.good) {
        this.threshold = this.aiThreshold.good;
      }
      let params = {
        camera: {
          targetFPS: 60,
          sizeOption: "640 X 480",
        },
        backend: "tfjs-webgl",
        flags: {
          WEBGL_VERSION: 2,
          WEBGL_CPU_FORWARD: true,
          WEBGL_PACK: true,
          WEBGL_FORCE_F16_TEXTURES: false,
          WEBGL_RENDER_FLOAT32_CAPABLE: true,
          WEBGL_FLUSH_THRESHOLD: -1,
        },
        modelConfig: {
          maxPoses: 1,
          type: "lightning",
          scoreThreshold: 0.3,
          customModel: "",
          enableTracking: false,
        },
        model: "MoveNet",
        lastTFJSBackend: "tfjs-webgl",
      };
      document
        .getElementById("similarityresult")
        .addEventListener("change", (event) => {
          this.score = event.target.value;
        });
      await initAiTracker(params);
      let yogaImg = document.getElementById("yogeposeimg");
      yogaImg.src = await this.loadImage(this.aiReferenceImage);

      this.eventInterval = setInterval(() => {
        if (this.score) {
          let result = this.score < this.threshold;
          this.emitResultEvent(result);
        }
      }, 1000);
    } catch (error) {
      console.error(error);
    }
    loader.hide();
  },

  computed: {
    isRed() {
      let bad = 0.27;
      if (this.aiThreshold) {
        bad = this.aiThreshold.bad || 0.27;
      }
      return this.score >= bad;
    },
    isYellow() {
      let bad = 0.27;
      let good = 0.04;
      if (this.aiThreshold) {
        bad = this.aiThreshold.bad || 0.27;
        good = this.aiThreshold.good || 0.04;
      }
      return this.score > good && this.score < bad;
    },
    isGreen() {
      let threshold = 0.04;
      if (this.aiThreshold && this.aiThreshold.good) {
        threshold = this.aiThreshold.good;
      }
      return this.score <= threshold;
    },
  },

  data() {
    return {
      score: null,
      refImageId: null,
      threshold: 0.05,
      eventInterval: null,
    };
  },

  beforeDestroy() {
    stopAnimation();
    clearInterval(this.eventInterval);
    stopVideoStream();
  },

  methods: {
    emitResultEvent(result) {
      this.$emit("result", result);
    },
    async loadImage(id) {
      if (this.device.platform == "iOS") {
        return await this.$store.dispatch("getFileUrl", this.fileId);
      } else {
        return this.baseUrl + "/file/public/" + id;
      }
    },
  },

  beforeDestroy() {
    stopAnimation();
    clearInterval(this.eventInterval);
    stopVideoStream();
  },
};
</script>

<style scoped>
.vid-container {
  display: flex;
  justify-content: center;
}

#similarityresult {
  display: none;
}

.red-border {
  border: 1px solid red;
  box-shadow: 0 0 10px red;
}

.yellow-border {
  border: 1px solid orange;
  box-shadow: 0 0 10px orange;
}

.green-border {
  border: 1px solid green;
  box-shadow: 0 0 10px green;
}

/* to keep the video in view for potrait mode in tablet*/
.canvas-wrapper {
  height: 23vh
}

#output {
  width: unset;
}
</style>
